export default "__VITE_ASSET__DXyFC2zw__"